import React from 'react';
interface InteractiveTOCProps {
  activeSection: string;
}
export function InteractiveTOC({
  activeSection
}: InteractiveTOCProps) {
  const reasons = [{
    id: 'reason-1',
    title: 'The Trigeminovascular Truth',
    subtitle: "Why Your 'Sinus Headaches' Are Actually Something Else"
  }, {
    id: 'reason-2',
    title: 'The $8,500 Medication Trap',
    subtitle: "Plus The FDA Warning Your Pharmacist Won't Mention"
  }, {
    id: 'reason-3',
    title: 'The 42°C Discovery',
    subtitle: "Why This Exact Temperature Targets Your Pain's Command Center"
  }, {
    id: 'reason-4',
    title: "The 'Impossible' Recovery Stories",
    subtitle: 'That Keep Neurologists Up At Night'
  }, {
    id: 'reason-5',
    title: 'The One-Time Investment',
    subtitle: 'That Replaces Your Entire Medicine Cabinet'
  }];
  return <div className="bg-white rounded-lg shadow-sm border border-[#F1F5F9] p-4" data-id="element-146">
      <h3 className="font-medium text-[#0F172A] mb-4" data-id="element-147">5 Reasons Why</h3>
      <ul className="space-y-4" data-id="element-148">
        {reasons.map((reason, index) => {
        const isActive = activeSection === reason.id;
        const isPast = activeSection && reasons.findIndex(r => r.id === activeSection) > reasons.findIndex(r => r.id === reason.id);
        return <li key={reason.id} className="group" data-id="element-149">
              <a href={`#${reason.id}`} className="flex items-start hover:bg-[#F1F5F9] rounded-md p-2 transition-colors" data-id="element-150">
                <div className={`
                  flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center mr-3 mt-0.5
                  ${isActive ? 'bg-[#0EA5B7] text-white' : isPast ? 'bg-[#F1F5F9] text-[#0EA5B7]' : 'bg-[#F1F5F9] text-[#334155]'}
                `} data-id="element-151">
                  {isPast ? <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-152">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-153" />
                    </svg> : <span className="text-xs font-medium" data-id="element-154">{index + 1}</span>}
                </div>
                <div data-id="element-155">
                  <div className={`text-sm font-medium ${isActive ? 'text-[#0EA5B7]' : 'text-[#0F172A]'}`} data-id="element-156">
                    {reason.title}
                  </div>
                  <div className="text-xs text-[#334155]" data-id="element-157">
                    {reason.subtitle}
                  </div>
                </div>
              </a>
            </li>;
      })}
      </ul>
    </div>;
}